import { CopyBlock, monoBlue } from "react-code-blocks";

const PreviewSection = ({getJsonData}) => {

    return(
        <div style={{ marginBottom: "10px", marginLeft: '20px'}}>
            <div
                id="formJsonPreview"
                style={{
                    display: "flex",
                    alignSelf: "center",
                    justifySelf: "center",
                    margin: "10px 0",
                }}
            >
            </div>
            <CopyBlock
                text={JSON.stringify(
                    getJsonData().srpContent ?? {},
                    null,
                    "    "
                )}
                language={"json"}
                showLineNumbers={true}
                customStyle={{
                    height: "400px",
                    overflow: "scroll",
                }}
                codeBlock
                theme={monoBlue}
                
            />
        </div>
    )
}

export default PreviewSection;